module.exports = __webpack_public_path__ + "static/media/Banner_Ooppah_Clube_Cesgranrio_2.b4d8a1f6.png";